import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, XIcon, MessageCircleIcon, ShoppingBagIcon } from 'lucide-react';
import { AIChatbot } from './AIChatbot';
interface SubButton {
  id: string;
  label: string;
  color: string;
  icon: React.ReactNode;
  onClick: () => void;
}
export function FloatingActions() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const handleChatOpen = () => {
    setIsExpanded(false);
    setIsChatOpen(true);
  };
  const subButtons: SubButton[] = [{
    id: 'shopee',
    label: 'Shopee',
    color: '#EE4D2D',
    icon: <ShoppingBagIcon className="w-5 h-5" data-id="element-196" />,
    onClick: () => {
      window.open('https://shopee.vn/mhp138', '_blank');
      setIsExpanded(false);
    }
  }, {
    id: 'chatbot',
    label: 'Trợ Lý AI',
    color: '#C8A84E',
    icon: <MessageCircleIcon className="w-5 h-5" data-id="element-197" />,
    onClick: handleChatOpen
  }, {
    id: 'zalo',
    label: 'Zalo',
    color: '#0068FF',
    icon: <span className="text-base font-bold leading-none" style={{
      fontFamily: 'system-ui'
    }} data-id="element-198">
          Z
        </span>,
    onClick: () => {
      window.open('https://zalo.me/0903302489', '_blank');
      setIsExpanded(false);
    }
  }];
  return <>
      {/* Backdrop when expanded */}
      <AnimatePresence data-id="element-199">
        {isExpanded && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[49] bg-black/20" onClick={() => setIsExpanded(false)} data-id="element-200" />}
      </AnimatePresence>

      {/* FAB Container */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col-reverse items-end gap-3" data-id="element-201">
        {/* Main FAB button */}
        {!isChatOpen && <motion.button onClick={() => setIsExpanded(!isExpanded)} className="w-14 h-14 rounded-full bg-gradient-to-br from-[#C8A84E] to-[#B8963E] shadow-lg shadow-[#C8A84E]/25 flex items-center justify-center text-[#0D0D0D] focus:outline-none active:scale-95 transition-transform" whileTap={{
        scale: 0.92
      }} aria-label={isExpanded ? 'Đóng menu' : 'Mở menu liên hệ'} data-id="element-202">
            <motion.div animate={{
          rotate: isExpanded ? 135 : 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} data-id="element-203">
              {isExpanded ? <XIcon className="w-6 h-6" data-id="element-204" /> : <PlusIcon className="w-6 h-6" data-id="element-205" />}
            </motion.div>
          </motion.button>}

        {/* Sub-buttons */}
        <AnimatePresence data-id="element-206">
          {isExpanded && <div className="flex flex-col items-end gap-3" data-id="element-207">
              {subButtons.map((btn, i) => <motion.div key={btn.id} initial={{
            opacity: 0,
            y: 20,
            scale: 0.6
          }} animate={{
            opacity: 1,
            y: 0,
            scale: 1
          }} exit={{
            opacity: 0,
            y: 10,
            scale: 0.6
          }} transition={{
            type: 'spring',
            stiffness: 400,
            damping: 22,
            delay: i * 0.06
          }} className="flex items-center gap-2.5" data-id="element-208">
                  {/* Label */}
                  <motion.span initial={{
              opacity: 0,
              x: 8
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: 8
            }} transition={{
              delay: i * 0.06 + 0.1
            }} className="px-3 py-1.5 bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg text-xs font-medium text-white shadow-lg whitespace-nowrap" data-id="element-209">
                    {btn.label}
                  </motion.span>

                  {/* Circle button */}
                  <button onClick={btn.onClick} className="w-12 h-12 rounded-full flex items-center justify-center text-white shadow-lg active:scale-90 transition-transform focus:outline-none" style={{
              backgroundColor: btn.color,
              boxShadow: `0 4px 14px ${btn.color}40`
            }} aria-label={btn.label} data-id="element-210">
                    {btn.icon}
                  </button>
                </motion.div>)}
            </div>}
        </AnimatePresence>
      </div>

      {/* AI Chatbot Panel */}
      <AIChatbot isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} data-id="element-211" />
    </>;
}